import React from 'react'

import FrameToolBar from '../../../Frame/Toolbar'
import { Filter, Search, Upload } from './Tools'
import { useFinder } from '../../hooks'
import { ACTION_TYPES } from '../../contexts/FinderContext'

const ToolBar = ({ close }) => {
  const [{ filter, query }, dispatch] = useFinder()
  const contacts = [] // TODO

  return (
    <FrameToolBar
      close={close}
      component={{ title: 'Files', type: 'finder', icon: 'folder' }}
      tools={[
        [<Upload key='upload' />],
        [
          <Search
            value={query}
            onChange={(query) =>
              dispatch({ type: ACTION_TYPES.UPDATE_QUERY, payload: query })
            }
            key='search'
          />,
          <Filter
            contacts={contacts}
            value={filter}
            onChange={(key, value) =>
              dispatch({
                type: ACTION_TYPES.UPDATE_FILTER,
                payload: { ...filter, [key]: value }
              })
            }
            key='filter'
          />
        ]
      ]}
    />
  )
}

export default ToolBar
